/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable func-names */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-console */
/* eslint no-param-reassign: "error" */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { blockUI, displayMessage, unblockUI } from '../../core_web/store/Application.store';
import ClientFactory from '../api/ApiFactory';
import { RelatorioResponseResult } from '../api/lar.logistica.api';
import { AppDispatch, AppThunk } from './index';

const Relatorio = createSlice({
  name: 'Relatorio',
  initialState: {
    RelatorioVencimento: {} as RelatorioResponseResult,
    RelatorioSolicitado: {} as RelatorioResponseResult
  },
  reducers: {
    setRelatorioVencimento(state, action: PayloadAction<RelatorioResponseResult>) {
      state.RelatorioVencimento = action.payload;
    },
    setRelatorioSolicitado(state, action: PayloadAction<RelatorioResponseResult>) {
      state.RelatorioSolicitado = action.payload;
    },
    resetData(state) {
      state.RelatorioVencimento = {} as RelatorioResponseResult;
      state.RelatorioSolicitado = {} as RelatorioResponseResult;
    }
  }
});

export const { setRelatorioVencimento, setRelatorioSolicitado, resetData } = Relatorio.actions;
export default Relatorio.reducer;

export function obterRelatorioVencimento(
  matricula: number,
  dataInicial: Date,
  dataFinal: Date
): AppThunk {
  return async function (dispatch: AppDispatch | any | any) {
    dispatch(blockUI());
    const client = ClientFactory.GetClient();
    client
      .apiV1RelatoriosVencimentos(matricula, dataInicial, dataFinal)
      .then((result) => {
        dispatch(setRelatorioVencimento(result.toJSON()));
        dispatch(
          displayMessage({
            message: `${result.data?.mensagem}`,
            severity: 'success'
          })
        );
      })
      .catch((err) => {
        dispatch(
          displayMessage({
            message:
              err.message === 'Unauthorized'
                ? 'Não Autorizado, Faça novamente o login'
                : `Não foi possivel obter o relatorio: ${err.message}`,
            severity: 'error'
          })
        );
      })
      .finally(() => dispatch(unblockUI()));
  };
}

export function obterRelatorioSolicitada(matricula: number, data: Date): AppThunk {
  return async function (dispatch: AppDispatch | any | any) {
    dispatch(blockUI());
    const client = ClientFactory.GetClient();
    client
      .apiV1RelatoriosCtesSolicitadas(matricula, data)
      .then((result) => {
        dispatch(setRelatorioSolicitado(result.toJSON()));
        dispatch(
          displayMessage({
            message: `${result.data?.mensagem}`,
            severity: 'success'
          })
        );
      })
      .catch((err) => {
        dispatch(
          displayMessage({
            message:
              err.message === 'Unauthorized'
                ? 'Não Autorizado, Faça novamente o login'
                : `Não foi possivel obter o relatorio: ${err.message}`,
            severity: 'error'
          })
        );
      })
      .finally(() => dispatch(unblockUI()));
  };
}

export function clearData(): AppThunk {
  return async function (dispatch: AppDispatch | any | any) {
    dispatch(resetData());
  };
}
